<template>
    <div class="domain-marketplace">
        <!-- 上方筛选区域 -->
        <el-card class="filter-area">
            <el-row :gutter="20">
                <!-- 左侧筛选条件 -->
                <el-col :span="12">
                    <div class="filter-section">
                        <div class="filter-header">
                            <i class="el-icon-search"></i>
                            <span>{{ $t('domain.include') }}</span>
                        </div>
                        <div class="filter-content">
                            <div class="filter-row">
                                <el-input size="small" v-model="includeKeywords" :placeholder="$t('domain.domainKeywords')" class="filter-input">
                                    <template slot="prepend">{{ $t('domain.contains') }}</template>
                                </el-input>
                                <el-checkbox-group v-model="includeOptions" class="checkbox-group">
                                    <el-checkbox label="start">{{ $t('domain.start') }}</el-checkbox>
                                    <el-checkbox label="end">{{ $t('domain.end') }}</el-checkbox>
                                    <el-checkbox label="startOrEnd">{{ $t('domain.startOrEnd') }}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                    
                    <div class="filter-section">
                        <div class="filter-header">
                            <i class="el-icon-close"></i>
                            <span>{{ $t('domain.excludeKeywords') }}</span>
                        </div>
                        <div class="filter-content">
                            <div class="filter-row">
                                <el-input size="mini" v-model="excludeKeywords" :placeholder="$t('domain.separatedBy')" class="filter-input">
                                    <template slot="prepend">{{ $t('domain.exclude') }}</template>
                                </el-input>
                                <el-checkbox-group size="mini" v-model="excludeOptions" class="checkbox-group">
                                    <el-checkbox label="start">{{ $t('domain.start') }}</el-checkbox>
                                    <el-checkbox label="end">{{ $t('domain.end') }}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </el-col>
                
                <!-- 右侧筛选条件 -->
                <el-col :span="12">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="filter-section">
                                <div class="filter-header">
                                    <i class="el-icon-menu"></i>
                                    <span>{{ $t('domain.domainLength') }}</span>
                                </div>
                                <div class="filter-content">
                                    <div class="filter-row length-selector">
                                        <el-select size="small" v-model="minLength" placeholder="1" class="length-input">
                                            <el-option v-for="i in 20" :key="`min-${i}`" :label="i" :value="i"></el-option>
                                        </el-select>
                                        <span class="separator">-</span>
                                        <el-select size="small" v-model="maxLength" placeholder="Max" class="length-input">
                                            <el-option v-for="i in 20" :key="`max-${i}`" :label="i" :value="i"></el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="filter-section">
                                <div class="filter-header">
                                    <i class="el-icon-tickets"></i>
                                    <span>{{ $t('domain.tlds') }}</span>
                                </div>
                                <div class="filter-content">
                                    <div class="filter-row">
                                        <el-select size="small" v-model="selectedTLDs" placeholder="All types" class="filter-select">
                                            <el-option value="all" :label="$t('domain.allTypes')"></el-option>
                                            <el-option v-for="tld in tldOptions" :key="tld.value" :label="tld.label" :value="tld.value"></el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        
                        <el-col :span="12">
                            <div class="filter-section">
                                <div class="filter-header">
                                    <i class="el-icon-date"></i>
                                    <span>{{ $t('domain.domainExpiration') }}</span>
                                </div>
                                <div class="filter-content">
                                    <div class="filter-row">
                                        <el-select size="small" v-model="expirationDate" placeholder="All types" class="filter-select">
                                            <el-option value="all" :label="$t('domain.allTypes')"></el-option>
                                            <el-option value="1year" :label="$t('domain.within1Year')"></el-option>
                                            <el-option value="2years" :label="$t('domain.within2Years')"></el-option>
                                            <el-option value="5years" :label="$t('domain.within5Years')"></el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="filter-section">
                                <div class="filter-header">
                                    <i class="el-icon-wallet"></i>
                                    <span>{{ $t('domain.priceRange') }}</span>
                                </div>
                                <div class="filter-content">
                                    <div class="filter-row price-range">
                                        <el-input size="small" v-model="minPrice" placeholder="Min" class="price-input">
                                            <template slot="prepend">$</template>
                                        </el-input>
                                        <span class="separator">-</span>
                                        <el-input size="small" v-model="maxPrice" placeholder="Max" class="price-input">
                                            <template slot="prepend">$</template>
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            
            <!-- 筛选按钮 -->
            <div class="filter-buttons">
                <el-button type="primary" class="search-btn" @click="searchDomains">{{ $t('domain.search') }}</el-button>
                <el-button class="reset-btn" @click="resetFilters">{{ $t('domain.reset') }}</el-button>
                <el-button type="text" class="save-preferences-btn" @click="savePreferences">{{ $t('domain.savePreferences') }}</el-button>
            </div>
        </el-card>
        
        <!-- 下方域名列表区域 -->
        <el-card class="domain-list-area">
            <div class="domain-list-header">
                <div class="result-info">
                    <span class="result-count">{{ $t('domain.foundCount', { count: totalCount }) }}</span>
                    <span class="current-page">{{ $t('domain.currentPage', { page: currentPage, total: totalPages }) }}</span>
                </div>
                <div class="sort-options">
                    <span>{{ $t('domain.sorting') }}:</span>
                    <el-select v-model="sortOption" placeholder="Sorting" size="small" class="sort-select">
                        <el-option v-for="option in sortOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
                    </el-select>
                    <el-dropdown @command="handlePerPage" trigger="click">
                        <span class="el-dropdown-link">
                            {{ perPage }} {{ $t('domain.perPage') }} <i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="num in [20, 50, 100, 200, 500]" :key="num" :command="num">{{ num }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            
            <el-table ref="domainTable" :data="domainList" style="width: 100%" class="domain-table" v-loading="isLoading">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="domain" :label="$t('domain.name')" min-width="200">
                    <template slot-scope="scope">
                        <div class="domain-name">
                            <span class="domain-text">{{ scope.row.domain }}</span>
                            <el-tooltip v-if="scope.row.popular" effect="dark" :content="$t('domain.popular')" placement="top">
                                <span class="popular-tag">{{ $t('domain.hot') }}</span>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="wage" :label="$t('domain.wage')" width="80" align="center"></el-table-column>
                <el-table-column prop="igoogle" :label="iGoogleLabel" width="80" align="center"></el-table-column>
                <el-table-column prop="da" :label="$t('domain.da')" width="60" align="center"></el-table-column>
                <el-table-column prop="pa" :label="$t('domain.pa')" width="60" align="center"></el-table-column>
                <el-table-column prop="tf" :label="$t('domain.tf')" width="60" align="center"></el-table-column>
                <el-table-column prop="cf" :label="$t('domain.cf')" width="60" align="center"></el-table-column>
                <el-table-column prop="backlinks" :label="$t('domain.backlinks')" width="90" align="center"></el-table-column>
                <el-table-column prop="referring" :label="$t('domain.referring')" width="90" align="center"></el-table-column>
                <el-table-column prop="expirationDate" :label="$t('domain.expirationDate')" width="120" align="center"></el-table-column>
                <el-table-column prop="price" :label="$t('domain.price')" width="100" align="center">
                    <template slot-scope="scope">
                        <span class="domain-price">${{ scope.row.price }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('domain.action')" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" class="buy-btn" @click="buyDomain(scope.row)">
                            {{ $t('domain.buy') }}
                        </el-button>
                        <el-button size="small" class="cart-btn" @click="addToCart(scope.row)">
                            <i class="el-icon-shopping-cart-2"></i>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class="domain-list-footer">
                <div class="bulk-actions">
                    <el-select v-model="bulkAction" placeholder="Bulk purchase" size="small" class="bulk-select">
                        <el-option :label="$t('domain.bulkPurchase')" value="purchase"></el-option>
                    </el-select>
                    <el-button size="small" @click="handleBulkAction">{{ $t('domain.submit') }}</el-button>
                </div>
                <div class="pagination-area">
                    <span class="per-page-text">{{ $t('domain.perPage') }}:</span>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[20, 50, 100, 200, 500]"
                        :page-size="perPage"
                        layout="sizes, prev, pager, next, jumper"
                        :total="totalCount">
                    </el-pagination>
                </div>
            </div>
        </el-card>

        <!-- 底部固定购物车 -->
        <div class="fixed-cart" v-show="cartItems.length > 0">
            <div class="cart-content">
                <div class="cart-info">
                    <i class="el-icon-shopping-cart-2"></i>
                    <span class="cart-count">{{ $t('domain.itemsInCart', { count: cartItems.length }) }}</span>
                    <span class="cart-price">{{ $t('domain.total') }}: <span class="price-value">${{ totalCartPrice }}</span></span>
                </div>
                <div class="cart-actions">
                    <el-button size="small" @click="viewCartItems">{{ $t('domain.viewCart') }}</el-button>
                    <el-button type="primary" size="small" @click="goToCheckout">{{ $t('domain.checkout') }}</el-button>
                </div>
            </div>
        </div>

        <!-- 购物车详情弹窗 -->
        <el-dialog
            :title="$t('domain.cart')"
            :visible.sync="cartDialogVisible"
            width="600px"
            class="cart-dialog">
            <div class="cart-dialog-content">
                <div v-if="cartItems.length === 0" class="empty-cart">
                    <i class="el-icon-shopping-cart-2"></i>
                    <p>{{ $t('domain.emptyCart') }}</p>
                </div>
                <div v-else>
                    <el-table :data="cartItems" style="width: 100%">
                        <el-table-column prop="domain" :label="$t('domain.name')" min-width="180"></el-table-column>
                        <el-table-column :label="$t('domain.period')" width="120">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.period" size="mini" style="width: 80px" @change="updateCartItemPrice(scope.$index)">
                                    <el-option 
                                        v-for="year in getAvailablePeriods(scope.row.suffix)" 
                                        :key="year" 
                                        :label="year + $t('domain.year')" 
                                        :value="year">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" :label="$t('domain.price')" width="100">
                            <template slot-scope="scope">
                                <span class="domain-price">${{ scope.row.price }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('domain.operation')" width="80" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" class="delete-btn" @click="removeFromCart(scope.$index)">
                                    <i class="el-icon-delete"></i>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="cart-footer">
                        <el-button @click="clearCart">{{ $t('domain.clearCart') }}</el-button>
                        <el-button type="primary" @click="goToCheckout">{{ $t('domain.checkout') }}</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'DomainMarketplace',
    data() {
        return {
            // 筛选参数
            includeKeywords: '',
            excludeKeywords: '',
            includeOptions: [],
            excludeOptions: [],
            minLength: 1,
            maxLength: null,
            selectedTLDs: 'all',
            expirationDate: 'all',
            registrationPeriod: 'all',
            minPrice: '',
            maxPrice: '',
            
            // 域名列表参数
            domainList: [],
            isLoading: false,
            totalCount: 0,
            currentPage: 1,
            totalPages: 1,
            perPage: 50,
            sortOption: 'price_asc',
            bulkAction: 'purchase',
            
            // 购物车参数
            cartItems: [],
            cartDialogVisible: false,
            
            // 选项数据
            tldOptions: [
                { label: '.com', value: '.com' },
                { label: '.net', value: '.net' },
                { label: '.org', value: '.org' },
                { label: '.cn', value: '.cn' },
                { label: '.co', value: '.co' }
            ],
            sortOptions: [
                { label: '价格升序', value: 'price_asc' },
                { label: '价格降序', value: 'price_desc' },
                { label: '域名长度升序', value: 'length_asc' },
                { label: '域名长度降序', value: 'length_desc' },
                { label: 'DA值降序', value: 'da_desc' },
                { label: 'PA值降序', value: 'pa_desc' },
                { label: '反向链接数降序', value: 'backlinks_desc' },
                { label: '引用域名数降序', value: 'referring_desc' }
            ]
        }
    },
    computed: {
        iGoogleLabel() {
            return 'iGoogle'
        },
        totalCartPrice() {
            return this.cartItems.reduce((total, item) => total + parseFloat(item.price), 0).toFixed(2)
        }
    },
    mounted() {
        this.loadDomainList()
        this.loadCartFromLocalStorage()
        this.loadPreferences()
    },
    watch: {
        // 监听购物车变化，确保价格正确显示并保存到本地存储
        'cartItems': {
            handler(newItems) {
                // 确保每个购物车项目都有正确的价格
                newItems.forEach((item, index) => {
                    if (item.period) {
                        this.updateCartItemPrice(index);
                    }
                });
                
                // 保存到本地存储
                this.saveCartToLocalStorage();
            },
            deep: true
        }
    },
    methods: {
        searchDomains() {
            this.currentPage = 1
            this.loadDomainList()
        },
        resetFilters() {
            this.includeKeywords = ''
            this.excludeKeywords = ''
            this.includeOptions = []
            this.excludeOptions = []
            this.minLength = 1
            this.maxLength = null
            this.selectedTLDs = 'all'
            this.expirationDate = 'all'
            this.registrationPeriod = 'all'
            this.minPrice = ''
            this.maxPrice = ''
        },
        savePreferences() {
            // 保存当前筛选条件到本地存储
            const preferences = {
                includeKeywords: this.includeKeywords,
                excludeKeywords: this.excludeKeywords,
                includeOptions: this.includeOptions,
                excludeOptions: this.excludeOptions,
                minLength: this.minLength,
                maxLength: this.maxLength,
                selectedTLDs: this.selectedTLDs,
                expirationDate: this.expirationDate,
                registrationPeriod: this.registrationPeriod,
                minPrice: this.minPrice,
                maxPrice: this.maxPrice,
                sortOption: this.sortOption,
                perPage: this.perPage
            }
            localStorage.setItem('domainMarketplacePreferences', JSON.stringify(preferences))
            this.$message.success(this.$t('domain.preferencesSaved'))
        },
        loadDomainList() {
            this.isLoading = true
            
            // 构建查询参数
            const params = {
                page: this.currentPage,
                limit: this.perPage,
                sort: this.sortOption,
                include: this.includeKeywords,
                exclude: this.excludeKeywords,
                includeStart: this.includeOptions.includes('start'),
                includeEnd: this.includeOptions.includes('end'),
                includeStartOrEnd: this.includeOptions.includes('startOrEnd'),
                excludeStart: this.excludeOptions.includes('start'),
                excludeEnd: this.excludeOptions.includes('end'),
                minLength: this.minLength,
                maxLength: this.maxLength,
                tld: this.selectedTLDs,
                expirationDate: this.expirationDate,
                registrationPeriod: this.registrationPeriod,
                minPrice: this.minPrice,
                maxPrice: this.maxPrice
            }
            
            // 模拟API请求
            setTimeout(() => {
                // 模拟数据
                this.totalCount = 270298
                this.totalPages = Math.ceil(this.totalCount / this.perPage)
                
                // 生成模拟数据
                this.domainList = this.generateMockDomainList()
                
                this.isLoading = false
            }, 800)
            
            // 实际项目中使用的API请求
            /*
            this.axios.post('/admin/domain/marketList', params, {
                token: true
            }).then(res => {
                const { status, data } = res
                if (status === 200 && data.code === 1) {
                    this.domainList = data.data.list
                    this.totalCount = data.data.total
                    this.totalPages = Math.ceil(this.totalCount / this.perPage)
                }
            }).catch(err => {
                console.error('获取域名列表失败', err)
                this.$message.error(this.$t('domain.loadError'))
            }).finally(() => {
                this.isLoading = false
            })
            */
        },
        generateMockDomainList() {
            // 生成一些模拟数据
            const mockList = []
            const domainExamples = [
                'changzhouzpw.com',
                '866xs.com',
                'xhyyds.cfd',
                'example.com',
                'bestdomain.net',
                'premium.org',
                'webstore.co',
                'digital.cn',
                'onlineshop.com',
                'cloudhosting.net'
            ]
            
            for (let i = 0; i < Math.min(this.perPage, 10); i++) {
                const domain = domainExamples[i % domainExamples.length]
                mockList.push({
                    domain,
                    wage: Math.floor(Math.random() * 5),
                    igoogle: Math.floor(Math.random() * 5),
                    da: Math.floor(Math.random() * 100),
                    pa: Math.floor(Math.random() * 100),
                    tf: Math.floor(Math.random() * 100),
                    cf: Math.floor(Math.random() * 100),
                    backlinks: Math.floor(Math.random() * 20) * 1000,
                    referring: Math.floor(Math.random() * 5) * 1000,
                    expirationDate: `202${Math.floor(Math.random() * 5) + 5}-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
                    price: (Math.floor(Math.random() * 10) * 100 + 100).toFixed(2),
                    popular: Math.random() > 0.8
                })
            }
            
            return mockList
        },
        handleSizeChange(size) {
            this.perPage = size
            this.loadDomainList()
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.loadDomainList()
        },
        handlePerPage(perPage) {
            this.perPage = perPage
            this.loadDomainList()
        },
        buyDomain(domain) {
            this.$message.success(`${this.$t('domain.addedToCart')}: ${domain.domain}`)
            this.addToCart(domain)
            
            // 跳转到结算页面
            setTimeout(() => {
                this.$router.push('/domain/checkout')
            }, 500)
        },
        addToCart(domain) {
            // 检查域名是否已在购物车中
            const exists = this.cartItems.some(item => item.domain === domain.domain)
            if (!exists) {
                // 添加到购物车
                this.cartItems.push({
                    domain: domain.domain,
                    price: domain.price,
                    period: 1,
                    suffix: '.' + domain.domain.split('.').slice(1).join('.')
                })
                
                // 保存到本地存储
                this.saveCartToLocalStorage()
                this.$message.success(`${this.$t('domain.addedToCart')}: ${domain.domain}`)
            } else {
                this.$message.warning(this.$t('domain.alreadyInCart'))
            }
        },
        viewCartItems() {
            this.cartDialogVisible = true
        },
        getAvailablePeriods(suffix) {
            // 默认提供1-10年的选项
            const defaultPeriods = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            
            // 如果有价格数据，则根据价格数据提供选项
            if (this.domainPriceData && this.domainPriceData[suffix] && this.domainPriceData[suffix].register) {
                return Object.keys(this.domainPriceData[suffix].register)
                    .map(year => parseInt(year))
                    .sort((a, b) => a - b);
            }
            
            return defaultPeriods;
        },
        updateCartItemPrice(index) {
            const item = this.cartItems[index];
            if (!item || !item.suffix || !item.period) return;
            
            // 从价格数据中获取对应期限的价格
            if (this.domainPriceData && 
                this.domainPriceData[item.suffix] && 
                this.domainPriceData[item.suffix].register && 
                this.domainPriceData[item.suffix].register[item.period]) {
                
                const price = this.domainPriceData[item.suffix].register[item.period];
                item.price = price.toFixed(2);
            }
        },
        removeFromCart(index) {
            this.cartItems.splice(index, 1)
            this.saveCartToLocalStorage()
        },
        clearCart() {
            this.cartItems = []
            localStorage.removeItem('domainCartItems')
            this.cartDialogVisible = false
        },
        goToCheckout() {
            // 检查用户是否已登录
            const token = window.sessionStorage.getItem('token');
            if (!token) {
                // 保存购物车数据和当前状态
                localStorage.setItem('domainCartItems', JSON.stringify(this.cartItems));
                localStorage.setItem('checkoutRedirect', 'true');
                
                // 提示用户需要登录
                this.$message.info(this.$t('message.noLogin'));
                
                // 跳转到登录页面
                this.$router.push({
                    path: '/login',
                    query: { redirect: 'domain_checkout' }
                });
                return;
            }
            
            // 已登录，将购物车数据保存到本地存储，以便结算页面使用
            localStorage.setItem('domainCartItems', JSON.stringify(this.cartItems));
            
            // 关闭购物车对话框
            this.cartDialogVisible = false
            
            // 跳转到结算页面
            this.$router.push('/domain/checkout');
        },
        handleBulkAction() {
            // 处理批量操作
            const selection = this.$refs.domainTable ? this.$refs.domainTable.selection : []
            if (selection.length === 0) {
                this.$message.warning(this.$t('domain.noDomainSelected'))
                return
            }
            
            if (this.bulkAction === 'purchase') {
                // 批量添加到购物车
                selection.forEach(domain => {
                    this.addToCart(domain)
                })
                
                // 跳转到结算页面
                this.$router.push('/domain/checkout')
            }
        },
        loadCartFromLocalStorage() {
            const savedCart = localStorage.getItem('domainCartItems');
            if (savedCart) {
                try {
                    this.cartItems = JSON.parse(savedCart);
                } catch (e) {
                    this.cartItems = [];
                }
            }
        },
        saveCartToLocalStorage() {
            localStorage.setItem('domainCartItems', JSON.stringify(this.cartItems));
        },
        loadPreferences() {
            const savedPreferences = localStorage.getItem('domainMarketplacePreferences')
            if (savedPreferences) {
                try {
                    const preferences = JSON.parse(savedPreferences)
                    // 加载保存的筛选条件
                    this.includeKeywords = preferences.includeKeywords || ''
                    this.excludeKeywords = preferences.excludeKeywords || ''
                    this.includeOptions = preferences.includeOptions || []
                    this.excludeOptions = preferences.excludeOptions || []
                    this.minLength = preferences.minLength || 1
                    this.maxLength = preferences.maxLength || null
                    this.selectedTLDs = preferences.selectedTLDs || 'all'
                    this.expirationDate = preferences.expirationDate || 'all'
                    this.registrationPeriod = preferences.registrationPeriod || 'all'
                    this.minPrice = preferences.minPrice || ''
                    this.maxPrice = preferences.maxPrice || ''
                    this.sortOption = preferences.sortOption || 'price_asc'
                    this.perPage = preferences.perPage || 50
                } catch (e) {
                    console.error('加载筛选条件失败', e)
                }
            }
        }
    }
}
</script>

<style scoped>
.domain-marketplace {
    padding: 20px;
    background-color: #f5f7fa;
    padding-bottom: 70px; /* 为固定底部购物车留出空间 */
}

.filter-area {
    margin-bottom: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    background-color: #fff;
}

.filter-section {
    margin-bottom: 15px;
    background-color: #fff;
    border-radius: 4px;
    padding: 5px 0;
}

.filter-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-weight: 500;
    color: #333;
    padding-bottom: 5px;
    border-bottom: 1px solid #f0f0f0;
}

.filter-header i {
    margin-right: 8px;
    color: #0052d9;
    font-size: 16px;
}

.filter-content {
    margin-bottom: 10px;
}

.filter-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
}

.filter-input {
    width: 60%;
    margin-right: 15px;
    margin-bottom: 0;
}

.filter-select {
    width: 100%;
}

.length-input {
    width: 45%;
}

.price-input {
    width: 45%;
}

.checkbox-group {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    white-space: nowrap;
}

.separator {
    margin: 0 10px;
    color: #606266;
}

.length-selector, .price-range {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.filter-buttons {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #ebeef5;
}

.search-btn, .reset-btn {
    min-width: 120px;
}

.search-btn {
    background-color: #0052d9;
    border-color: #0052d9;
}

.search-btn:hover {
    background-color: #0045b8;
    border-color: #0045b8;
}

.save-preferences-btn {
    align-self: center;
    color: #0052d9;
}

.save-preferences-btn:hover {
    color: #0045b8;
}

/* 自定义 Element UI 组件样式 */
.filter-area /deep/ .el-input__inner {
    border-radius: 2px;
}

.filter-area /deep/ .el-input-group__prepend {
    background-color: #f5f7fa;
    color: #606266;
    border-color: #dcdfe6;
}

.filter-area /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.filter-area /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #0052d9;
    border-color: #0052d9;
}

.filter-area /deep/ .el-checkbox__label {
    font-size: 12px;
}

.filter-area /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: #0052d9;
}

.filter-area /deep/ .el-select-dropdown__item.selected {
    color: #0052d9;
}

.domain-list-area {
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.domain-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
}

.result-info {
    display: flex;
    flex-direction: column;
}

.result-count {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

.current-page {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
}

.sort-options {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #606266;
}

.sort-select {
    width: 140px;
}

.el-dropdown-link {
    cursor: pointer;
    color: #606266;
}

.domain-table {
    margin-bottom: 20px;
    border-radius: 4px;
}

.domain-name {
    display: flex;
    align-items: center;
}

.domain-text {
    font-weight: 500;
    color: #333;
}

.popular-tag {
    display: inline-block;
    padding: 2px 6px;
    margin-left: 10px;
    background-color: #ff9900;
    color: white;
    border-radius: 2px;
    font-size: 12px;
}

.domain-price {
    font-weight: 500;
    color: #ff6700;
}

.buy-btn {
    margin-right: 5px;
    background-color: #0052d9;
    border-color: #0052d9;
}

.cart-btn {
    padding: 7px 10px;
}

.domain-list-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    border-top: 1px solid #ebeef5;
}

.bulk-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

.bulk-select {
    width: 140px;
}

.pagination-area {
    display: flex;
    align-items: center;
}

.per-page-text {
    margin-right: 10px;
    font-size: 14px;
    color: #606266;
}

/* 底部固定购物车样式 */
.fixed-cart {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    padding: 10px 20px;
    border-top: 1px solid #ebeef5;
    transition: all 0.3s ease;
}

.cart-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
}

.cart-info {
    display: flex;
    align-items: center;
}

.cart-info i {
    font-size: 24px;
    color: #0052d9;
    margin-right: 10px;
}

.cart-count {
    margin-right: 20px;
    font-size: 14px;
}

.cart-price {
    font-size: 14px;
}

.price-value {
    font-weight: bold;
    color: #ff6700;
    font-size: 16px;
}

.cart-actions {
    display: flex;
    gap: 10px;
}

/* 购物车弹窗样式 */
.cart-dialog-content {
    max-height: 400px;
    overflow-y: auto;
}

.empty-cart {
    text-align: center;
    padding: 30px 0;
    color: #909399;
}

.empty-cart i {
    font-size: 48px;
    margin-bottom: 10px;
}

.cart-footer {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.delete-btn {
    color: #F56C6C;
}

.delete-btn:hover {
    color: #F78989;
}
</style> 